module.exports = __webpack_public_path__ + "img/scope1category1.7b550215.svg";